import { render, staticRenderFns } from "./OnderdeelCard.vue?vue&type=template&id=da4915de"
import script from "./OnderdeelCard.vue?vue&type=script&lang=js"
export * from "./OnderdeelCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports